import { Stack } from 'rsuite';

import { progressCardStyle } from '../styles';
import { ProgressBar } from './ProgressBar';

export const LoadingView = ({ progress }) => {
  return (
    <Stack alignItems="stretch" justifyContent="flex-start" direction="column" style={{ marginTop: 8 }}>
      <Stack.Item style={progressCardStyle}>
        <ProgressBar percentage={progress} />
      </Stack.Item>
    </Stack>
  );
};
